import { render } from "./sorter.module.vue?vue&type=template&id=1f55e815&scoped=true"
import script from "./sorter.module.vue?vue&type=script&lang=js"
export * from "./sorter.module.vue?vue&type=script&lang=js"

import "./sorter.module.vue?vue&type=style&index=0&id=1f55e815&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f55e815"]])

export default __exports__